<template>
  <div class="panel-body">
    <div class="left">
      <p>出金方法を選択し、必要情報を入力して下さい。</p>
      <br>
      <div class="deposit-type">
        <div class="bank flexbox" data-vv-scope="form-bank">
          <div class="radio">
            <input type="radio" value="10" id="bank" v-model="paymentInfo.paymentMethodCode" data-vv-scope="form-bank">
            <label for="bank"></label>
          </div>
          <div class="pd-l-30 flex-grow">
            <span class="type-description">銀行口座</span>
            <div :class="{ 'pointer-none' : isPaypalMethod }" class="hpanel panel-group pd-l-40 panel-pd-b-5" id="payment" role="tablist" aria-multiselectable="true">
              <div class="panel-body qa-block panel-temp">
                <div data-toggle="collapse" data-parent="#payment" :data-target="'#payment-method'" aria-expanded="true" class="question collapsed m-l pointer-cursor accordion-title collapsed-temp">
                  <div class="panel-temp-text">口座設定のテンプレートを利用する場合は、こちらより選択してください</div>
                  <i class="fa fa-chevron-down accordion-arrow text-muted panel-temp-icon"></i>
                </div>
                <div :id="'payment-method'" class="panel-collapse collapse in" aria-expanded="true">
                  <div class="flexbox m-t-sm m-l-md m-r-md" >
                    <div class="m-r-xs" v-for="(method, index) in paymentMethodCn" :key="method.id + '-' + index">
                      <button :class="{'highlight-btn' : paymentBtnId === 'btn-' + index}" :id="'btn-' + index" class="btn btn-info btn-margin" @click.prevent="displayMethodContent(method, $event)" v-html="method.displayPaymentName"></button>
                    </div>
                  </div>
                  <div v-if="paymentDescription" class="m-t-sm m-l-md m-r-md p-xxs" v-html="paymentDescription"></div>
                </div>
              </div>
            </div>
            <div class="bank-info pd-l-40">
              <div class="form-group flexbox">
                <label class="control-label flex-item flex-lable flexbox justify-between label-width">金融機関<span class="text-danger m-r-sm">＊</span></label>
                <div class="flex-item flex-input">
                  <selectize
                    v-model="paymentInfo.bankCode"
                    :settings="settings"
                    @input="setBankcode"
                    v-validate="'required'"
                    data-vv-name="form-bank.bankCode"
                    data-vv-as="金融機関"
                    data-vv-scope="form-bank"
                    :disabled="isPaypalMethod"
                  >
                    <option
                      :value="bank.code"
                      v-for="(bank, index) in zengin"
                      :selected="defaultPaymentInfo.bankCode === bank.code"
                      :key="index"
                    >
                      {{ bank.code + ' ' + bank.name }}
                    </option>
                  </selectize>
                  <span style="display: block" v-show="errors.has('form-bank.bankCode')" class="text-danger">
                    ※{{ errors.first('form-bank.bankCode') }}
                  </span>
                </div>
              </div>
              <div class="form-group flexbox">
                <label class="control-label flex-item flex-lable flexbox justify-between label-width">支店<span class="text-danger m-r-sm">＊</span></label>
                <div class="flex-item flex-input">
                  <selectize
                    v-model="paymentInfo.bankBranchCode"
                    :settings="settings"
                    @input="setBranchcode"
                    v-validate="'required'"
                    data-vv-name="form-bank.bankBranchCode"
                    data-vv-as="支店"
                    data-vv-scope="form-bank"
                    :disabled="isPaypalMethod"
                  >
                    <option
                      :value="branch.code"
                      v-for="(branch, index) in branches"
                      :selected="defaultPaymentInfo.bankBranchCode === branch.code"
                      :key="index"
                    >
                      {{ branch.code + ' ' + branch.name }}
                    </option>
                  </selectize>
                  <span style="display: block" v-show="errors.has('form-bank.bankBranchCode')" class="text-danger">
                    ※{{ errors.first('form-bank.bankBranchCode') }}
                  </span>
                </div>
              </div>
              <div class="form-group flexbox">
                <label class="control-label flex-item flex-lable flexbox justify-between label-width">預金種目<span class="text-danger m-r-sm">＊</span></label>
                <div class="flex-item flex-input">
                  <select
                    name="bankDepositcategoryCode"
                    class="form-control"
                    v-model="paymentInfo.bankDepositcategoryCode"
                    v-validate="'required'"
                    data-vv-scope="form-bank"
                    data-vv-as="預金種目"
                    :disabled="isPaypalMethod"
                  >
                    <option
                      :value="category.depositCategoryCode"
                      v-for="category in depositCategories"
                      :key="category.depositCategoryCode"
                    >
                      {{ category.depositCategoryName }}
                    </option>
                  </select>
                  <span style="display: block" v-show="errors.has('form-bank.bankDepositcategoryCode')" class="text-danger">
                    ※{{ errors.first('form-bank.bankDepositcategoryCode') }}
                  </span>
                </div>
              </div>
              <div class="form-group flexbox">
                <label class="control-label flex-item flex-lable flexbox justify-between label-width">口座番号<span class="text-danger m-r-sm">＊</span></label>
                <div class="flex-item flex-input">
                  <input
                    name="bankAccountNumber"
                    class="form-control"
                    type="text"
                    maxlength="7"
                    v-validate="'required|bankAccountOnlyNumber|max:7|justNumberLength:7'"
                    v-model.trim="paymentInfo.bankAccountNumber"
                    data-vv-as="口座番号"
                    data-vv-scope="form-bank"
                    :disabled="isPaypalMethod"
                  >
                  <span style="display: block" v-show="errors.has('form-bank.bankAccountNumber')" class="text-danger">
                    ※{{ errors.first('form-bank.bankAccountNumber') }}
                  </span>
                </div>
              </div>
              <div class="form-group flexbox">
                <label class="control-label flex-item flex-lable flexbox justify-between label-width">口座名義（カナ）<span class="text-danger m-r-sm">＊</span></label>
                <div class="flex-item flex-input">
                  <input
                    name="bankAccountName"
                    class="form-control"
                    type="text"
                    v-validate="'required|max:150|bankAccountOnlyName'"
                    v-model.trim="paymentInfo.bankAccountName"
                    data-vv-as="口座名義（カナ）"
                    data-vv-scope="form-bank"
                    :disabled="isPaypalMethod"
                  >
                  <span style="display: block" v-show="errors.has('form-bank.bankAccountName')" class="text-danger">
                    ※{{ errors.first('form-bank.bankAccountName') }}
                  </span>
                </div>
                <div class="flex-item flex-input">
                  <div class="example-quate">
                    <p>入力可能な文字種:</p>
                    <p>１２３４５６７８９０ＡＢＣＤＥＦＧＨＩＪＫＬＭＮＯＰＱＲＳＴＵＶＷＸＹＺアイウエオカキクケコサシスセソタチツテトナニヌネノハヒフヘホマミムメモヤユヨラリルレロワヲンガギグゲゴザジズゼソダヂヅデドバビブベボパピプペポヴ（）．－</p>
                    <p>例: ｶ) → カ）</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="paypal flexbox mr-t-30" data-vv-scope="form-paypal">
          <div class="radio">
            <input type="radio" value="7A" id="paypal" v-model="paymentInfo.paymentMethodCode" data-vv-scope="form-paypal">
            <label for="paypal"></label>
          </div>
          <div class="pd-l-10 flex-grow">
            <span class="type-description">Paypal</span>
            <div class="paypal-info pd-l-40">
              <p>※PayPalの場合、決済手数料は受取者様ご負担となります。</p>
              <span>
                （ペイパル手数料は
                <a class="text--underline" href="https://www.paypal.com/jp/webapps/mpp/merchant/paypal-seller-fees" target="_blank">
                  こちら
                </a>
                ）
              </span>
              <div class="form-group flexbox">
                <label class="control-label flex-item flex-lable flexbox justify-between label-width">ペイパルアカウント<span class="text-danger m-r-sm">＊</span></label>
                <div class="flex-item flex-input">
                  <span style="display: block" v-show="errors.has('form-paypal.paypalAccountName')" class="text-danger">
                    ※{{ errors.first('form-paypal.paypalAccountName') }}
                  </span>
                  <input
                    name="paypalAccountName"
                    class="form-control"
                    type="text"
                    v-validate="'max:150'"
                    v-model.trim="paymentInfo.paypalAccountName"
                    data-vv-as="ペイパルアカウント"
                    data-vv-scope="form-paypal"
                    :disabled="!isPaypalMethod"
                  >
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="update-btn">
        <button class="btn btn-info w-120" @click.prevent="openModalConfirmPassword()" :disabled="disabled">更新</button>
      </div>
    </div>
    <modal-confirm-password v-if="showModalConfirmPassword" @resetErr="resetErr()" @confirm="handleSubmit" @close="closeModalConfirmPassword" :err="errorMessage"></modal-confirm-password>
  </div>
</template>
<script>
import BankService from '@/services/bankservice'
import { mapGetters } from 'vuex'
import SettingService from '@/services/settingservice'
import ModalConfirmPassword from '@/components/ModalConfirmPassword'
import Const from '@/common/msg'
import Util from '@/common/utility'
import Selectize from 'vue2-selectize'
import EventService from '@/services/eventservice'
import eventCode from '@/common/event-code'

export default {
  props: {
    currentTab: {
      type: String,
      default: ''
    }
  },
  components: {
    ModalConfirmPassword,
    Selectize
  },

  data () {
    return {
      paymentInfo: {
        bankCode: null,
        bankName: null,
        bankBranchName: null,
        bankBranchCode: null,
        bankDepositcategoryCode: null,
        bankAccountNumber: null,
        bankAccountName: null,
        paypalAccountName: null,
        paymentMethodCode: '10'
      },
      defaultPaymentInfo: {},
      depositCategories: [],
      disabled: true,
      isSuccess: false,
      err: null,
      loader: null,
      showModalConfirmPassword: false,
      serviceDone: 0,
      errorMessage: null,
      downloadUrl: `${process.env.NODE_DOMAIN}/static/dists/pdf/payoneer.pdf`,
      zengin: null,
      branches: null,
      settings: {
        maxOptions: 1500
      },
      paymentMethodCn: [],
      paymentDescription: null,
      paymentBtnId: null
    }
  },
  created () {
    this.getAllBanks()
    this.getPaymentInfo()
    this.getDepositCategory()
    this.getPaymentMethod()
  },
  mounted () {
    this.checkDisabledButton()
    if (this.currentTab && this.currentTab === 'payment-info') {
      let logParams = {
        name: eventCode.settings.payment_info_tab.show,
        properties: {}
      }
      EventService.postTrackLog(logParams)
    }
  },
  beforeDestroy () {
    this.loader && this.loader.hide()
    this.closeModalConfirmPassword()
  },
  watch: {
    'paymentInfo.paymentMethodCode' (newVal, oldVal) {
      const oldScope = (oldVal === '10') ? 'form-bank' : 'form-paypal'
      let matcher = {
        scope: oldScope,
        vmId: this.$validator.id
      }
      this.$validator.reset(matcher)
    },
    paymentInfo: {
      handler () {
        setTimeout(() => this.checkDisabledButton(), 100)
      },
      deep: true
    },
    serviceDone (newVal) {
      if (newVal === 2 && this.$route.params.tab === 'payment-info') {
        this.$events.fire('done')
      }
    }
  },
  computed: {
    isPaypalMethod () {
      return this.paymentInfo.paymentMethodCode === '7A'
    },
    scope () {
      return this.isPaypalMethod ? 'form-paypal' : 'form-bank'
    },
    ...mapGetters({
      isShowModal: 'getIsShowModal',
      userInfo: 'getUser'
    })
  },
  methods: {
    /*
     * Check disabled button
     *
     * @return void
     */
    async checkDisabledButton () {
      const result = await this.$validator.validate(null, null, { silent: true })
      this.disabled = !result
    },
    /*
     * Get payment info
     *
     * @return void
     */
    getPaymentInfo () {
      SettingService.getPaymentInfo()
        .then((response) => {
          this.paymentInfo = {
            ...response.withdrawal,
            paymentMethodCode: response.withdrawal.paymentMethodCode || '10'
          }
          this.serviceDone += 1
          this.defaultPaymentInfo = {...this.paymentInfo}
          this.getBranchList(this.defaultPaymentInfo.bankCode)
        })
        .catch((err) => {
          this.err = err
        })
    },
    /*
     * Get deposit categories
     *
     * @return void
     */
    getDepositCategory () {
      SettingService.getDepositCategory()
        .then((response) => {
          this.serviceDone += 1
          this.depositCategories = [
            {
              depositCategoryCode: null,
              depositCategoryName: ''
            },
            ...response.categories
          ]
        })
        .catch((err) => {
          this.err = err
        })
    },

    /*
     * Call API to update payment info
     *
     * @return void
     */
    async handleSubmit (password = '') {
      let logParams = {
        name: eventCode.settings.payment_info_tab.click_update_button,
        properties: {
          oldPaymentInfo: this.defaultPaymentInfo,
          newPaymentInfo: this.paymentInfo
        }
      }
      EventService.postTrackLog(logParams)

      let result = await this.$validator.validateAll(this.scope)
      if (result) {
        this.loader = this.$loading.show()
        const payload = {
          password: password,
          record: {
            ...Util.transformNull(this.paymentInfo)
          }
        }
        SettingService.postPaymentInfo(payload)
          .then((response) => {
            this.defaultPaymentInfo = {...this.paymentInfo}
            this.closeModalConfirmPassword()
            this.getPaymentInfo()

            this.$store.commit('toggleModal', {
              show: true,
              message: Const.updateSuccess
            })

            this.isSuccess = true
          })
          .catch((err) => {
            this.err = err
            this.errorMessage = err
            // 変更項目は画面更新しない
            // if (Const.confirmErr !== err) {
            //   this.paymentInfo = {...this.defaultPaymentInfo}
            // }
          })
          .finally(() => {
            this.loader && this.loader.hide()
          })
      }
    },

    resetErr () {
      this.errorMessage = null
    },

    openModalConfirmPassword () {
      this.errorMessage = null
      this.showModalConfirmPassword = true
    },

    closeModalConfirmPassword () {
      $('#confirmPassword').modal('hide')
      this.showModalConfirmPassword = false
    },

    getAllBanks () {
      BankService.getAllBanks()
        .then((response) => {
          var self = this
          self.zengin = response.data
        })
        .catch((err) => {
          this.$store.commit('toggleModal', {
            show: true,
            message: err
          })
        })
    },

    getBranchList (bankCode) {
      BankService.getBranches({ bankCode: bankCode })
        .then((response) => {
          var self = this
          self.branches = response.data
        })
        .catch((err) => {
          this.$store.commit('toggleModal', {
            show: true,
            message: err
          })
        })
    },

    setBankcode () {
      if (this.paymentInfo.bankCode) {
        const bank = this.zengin.find(data => data.code === this.paymentInfo.bankCode)
        if (bank !== undefined && bank !== null) {
          this.paymentInfo.bankName = bank.name
          this.getBranchList(bank.code)
        } else {
          this.paymentInfo.bankName = null
          this.paymentInfo.bankBranchName = null
        }
      } else {
        this.paymentInfo.bankName = null
        this.paymentInfo.bankBranchName = null
      }
    },

    setBranchcode () {
      if (this.paymentInfo.bankBranchCode) {
        const branch = this.branches.find(data => data.code === this.paymentInfo.bankBranchCode)
        if (branch !== undefined && branch !== null) {
          this.paymentInfo.bankBranchName = branch.name
        } else {
          this.paymentInfo.bankBranchName = null
        }
      } else {
        this.paymentInfo.bankBranchName = null
      }
    },

    getPaymentMethod () {
      this.loader = this.$loading.show()
      SettingService.getPaymentMethod()
        .then((response) => {
          this.paymentMethodCn = response.data
        })
        .catch((err) => {
          this.err = err
        })
        .finally(() => {
          this.loader && this.loader.hide()
        })
    },

    displayMethodContent (method, events) {
      this.paymentBtnId = events.currentTarget.id
      this.paymentDescription = method.description
      this.paymentInfo.bankCode = method.bankCode
      this.setBankcode()
      this.paymentInfo.bankBranchCode = method.bankBranchCode
      this.setBranchcode()
      this.paymentInfo.bankAccountNumber = method.bankAccountNumber
      this.paymentInfo.bankDepositcategoryCode = method.bankDepositCategoryCode
      this.paymentInfo.bankAccountName = method.bankAccountName
    }
  }
}
</script>

<style scoped>
.pointer-none {
  pointer-events:none;
}
.panel-temp {
  padding: 0px 10px 10px 10px;
  margin-right: 5px;
  border: 1px solid #CCCCCC;
  background-color: #fcf8e3;
}
.panel-pd-b-5 {
  margin-bottom: 5px !important;
}
.collapsed-temp {
  padding-top: 10px !important;
}
.panel-temp-text {
  margin-left: -10px !important;
  font-weight: 600;
  color: #008cc6;
}
.panel-temp-icon {
  margin-right: 5px
}
.highlight-btn {
  background-color: #0da9b5;
}
.btn-margin {
  margin:0 0 5px 0;
}
</style>



// WEBPACK FOOTER //
// src/view/setting/PayInfo.vue